import { useEffect, useState } from 'react';

interface InstallEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let deferred: InstallEvent | null = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferred = e as InstallEvent;
});

/** "Installeren als app": Chrome/Edge/Android met één klik, iPhone/iPad via Delen → Zet op beginscherm. */
export function InstallApp() {
  const [canPrompt, setCanPrompt] = useState(!!deferred);
  const [done, setDone] = useState(false);
  const standalone = window.matchMedia?.('(display-mode: standalone)').matches || (navigator as unknown as { standalone?: boolean }).standalone === true;
  const ios = /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  useEffect(() => {
    const on = () => setCanPrompt(true);
    window.addEventListener('beforeinstallprompt', on);
    return () => window.removeEventListener('beforeinstallprompt', on);
  }, []);

  if (standalone) return null;

  const install = async () => {
    if (!deferred) return;
    await deferred.prompt();
    const r = await deferred.userChoice;
    deferred = null;
    setCanPrompt(false);
    if (r.outcome === 'accepted') setDone(true);
  };

  return (
    <section className="settings-block" aria-label="Installeren als app">
      <h2>Installeren als app</h2>
      {done ? (
        <p className="subtle">Geïnstalleerd. Je vindt tumedia nu tussen je apps.</p>
      ) : canPrompt ? (
        <>
          <p className="subtle hint">Open tumedia als losse app, zonder adresbalk, met een eigen icoon.</p>
          <button className="btn btn-primary btn-sm" onClick={() => void install()}>Installeren</button>
        </>
      ) : ios ? (
        <p className="subtle hint">Op iPhone of iPad: tik in Safari op <strong>Delen</strong> (vierkant met pijl) en kies <strong>Zet op beginscherm</strong>. tumedia opent dan schermvullend als app.</p>
      ) : !window.isSecureContext ? (
        <p className="subtle hint">Installeren kan alleen via https, bijvoorbeeld via je eigen domein (tv.tumedia.nl). Op het thuisnetwerk via http:// werkt het niet.</p>
      ) : (
        <p className="subtle hint">Gebruik in je browser het menu (⋮) → <strong>App installeren</strong> of <strong>Toevoegen aan startscherm</strong>.</p>
      )}
    </section>
  );
}
